export function createAction(type, payload) {
    return payload === undefined ? { type: type } : { type: type, payload: payload };
}
//# sourceMappingURL=createAction.js.map